<script>
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      activeFilters: [],
      filterModalOpened: false
    }
  },
  mounted() {
    this.initFilters();
    this.filter(false);
    // slice at 5 because 'page-' is 5 characters long
    sendFandomAnalyticsEvent(this.mainContent.name.slice(5).split('-').map(str => Fandom.capitalize(str)).join(''), 'KnowledgeHub', this.content.name);
  },
  methods: {
    clearAllBodyScrollLocks: clearAllBodyScrollLocks,
    initFilters(reset=false) {
      const params = new URLSearchParams(window.location.search);
      const filters = params.get('filters');
      if (!!filters && !reset) {
        this.activeFilters = JSON.parse(filters);
      } else {
        this.activeFilters = [];
        this.content.filters.forEach(filter => {
          Vue.set(this.activeFilters, this.activeFilters.length, []);
        });
        this.filter();
      }
    },
    closeModal() {
      this.filterModalOpened = false;
      VodafoneLab.addDigitalDataEvent("search_refine", "search", ":Filters close");
      clearAllBodyScrollLocks();
    },
    openModal() {
      this.filterModalOpened = true;
      VodafoneLab.addDigitalDataEvent("search_refine", "search", ":Filters open");
      Vue.nextTick(() => {
        disableBodyScroll(this.$refs["filter-menu"]);
      })
    },
    isFilterActive(filter, topIndex) {
      return (this.activeFilters[topIndex] || []).includes(filter);
    },
    toggleFilter(topIndex, filter, applyImmediately) {
      const filterInnerIndex = this.activeFilters[topIndex].indexOf(filter);
      if (filterInnerIndex > -1) {
        this.activeFilters[topIndex].splice(filterInnerIndex,1);
        if (this.getContent(filter).parent_names.includes('industry') && this.activeFilters[topIndex].length == 1 && this.activeFilters[topIndex][0] == 'industry-all') {
          Vue.set(this.activeFilters, topIndex, []);
        }
      } else {
        if (this.getContent(filter).parent_names.includes('industry') && !this.activeFilters[topIndex].includes('industry-all')) {
          this.activeFilters[topIndex].push('industry-all');
        }
        this.activeFilters[topIndex].push(filter);
      }

      if (applyImmediately) {
        this.filter();
      }
    },
    filter(triggerWaGc=true) {
      Vue.nextTick(() => {
        Fandom.getContents(
          this.content.main_content,
          this.appendContentsParams,
          (data) => {
            const filtersActive = this.activeFilters.reduce((response,filters) => (response || filters.length > 0), false);
            const urlParams = new URLSearchParams(window.location.search);
            const queryString = Array.from(urlParams.entries())
              .filter(entry => entry[0] !== 'filters')
              .map(entry => `${entry[0]}=${entry[1]}`)
              .join('&');
            if (filtersActive) {
              const activeFiltersSerialized = encodeURIComponent(JSON.stringify(this.activeFilters));
              history.pushState({}, '', `${window.location.origin}${window.location.pathname}?filters=${activeFiltersSerialized}&${queryString}`);
            } else {
              history.pushState({}, '', `${window.location.origin}${window.location.pathname}?${queryString}`);
            }
            if (triggerWaGc) {
              if (data.name_to_content[data.main_content_name].children && data.name_to_content[data.main_content_name].children.length > 0) {
                VodafoneLab.addDigitalDataEvent("search_apply", "search", ":Search apply");
              } else {
                VodafoneLab.addDigitalDataEvent("search_zero_results", "search", ":Search apply");
              }
            }
          }
        )
      })
    },
    availableFilters(parentName) {
      const parent = this.getContent(parentName);
      if (parent.children && parent.children.length && parent.children.length > 0) {
        if (!this.mainContent.content_filtering) {
          return parent.children.filter(childName => childName != 'industry-all');
        } else {
          return parent.children.filter(childName => {
            return this.getContent(childName).parent_names.includes(this.mainContent.content_filtering) && childName != 'industry-all';
          })
        }
      } else {
        return [];
      }
    }
  },
  computed: {
    appendContentsParams() {
      const contentParams = {
        content_filtering: this.activeFilters,
        include_children: true,
        include_content_children: true,
        layout: "grid-isotope",
        // SEO pagination management
        page_content_name: Fandom.getUrlParameter("page_content_name"),
        page: Fandom.getUrlParameter("page")
      };
      if (this.content.limit) {
        contentParams.limit = this.content.limit;
      }

      return contentParams;
    },
    resultContent() {
      return this.getContent(this.content.main_content);
    },
    activeFiltersList() {
      const result = [];
      this.activeFilters.forEach((filterArray, topIndex) => {
        filterArray.forEach(filter => {
          if (filter != 'industry-all') {
            result.push({value: filter, topIndex: topIndex})
          }
        });
      });
      return result;
    }
  }
};

</script>

<template>
  <div
    v-if="isContentVisibleToUser()"
    v-easyadmin="easyadminId"
    class="bg-gray-200"
    :class="contentType"
    filters-component
  >
    <div class="container px-3 px-sm-0">
      <div class="d-flex flex-wrap pt-5 align-items-sm-center justify-content-between flex-sm-row flex-column">
        <component v-if="content.title" :is="content.title_tag || 'h2'" :class="content.title_class || 'h2'">{{content.title}}</component>
        <div class="filters-toggler cursor-pointer d-inline-block px-3 py-2 d-flex justify-content-between align-items-center mb-2 bg-white" id="filters-input" @click="openModal()">
          {{ft('globals.filters')}}
          <i class="fal fa-sliders-h"></i>
        </div>
      </div>
      <div class="mt-md-4 d-flex flex-wrap align-items-center justify-content-sm-end">
        <div v-for="activeFilter in activeFiltersList" :key="`activeFilter-${activeFilter.topIndex}-${activeFilter.value}`" class=" small py-2 px-3 filter-item m-2 active d-flex align-items-center">
          {{getContent(activeFilter.value).title}}
          <i class="fal fa-times cursor-pointer ml-2" @click="toggleFilter(activeFilter.topIndex, activeFilter.value, true)"></i>
        </div>
      </div>
    </div>
    <!-- RESULTS GRID -->
    <grid-isotope v-if="!!resultContent" :content="resultContent" :opt-container-content="containerContent" :append-contents-params="appendContentsParams"></grid-isotope>
    <!-- END RESULTS GRID -->
    <!-- FILTER MODAL -->
    <transition enter-active-class="animated faster fadeIn" leave-active-class="animated faster fadeOut">
      <div class="layer position-fixed bg-gray-500" v-if="filterModalOpened">
        <div class="close-icon position-absolute cursor-pointer" @click="closeModal()">
          <i class="fal fa-times"></i>
        </div>
      </div>
    </transition>
    <transition enter-active-class="animated faster slideInLeft" leave-active-class="animated faster slideOutLeft">
      <div class="filter-menu position-fixed bg-white p-4 p-md-5" ref="filter-menu" v-if="filterModalOpened">
        <div v-for="(topFilter, topIndex) in content.filters" :key="`filter-collapse-${topIndex}`" class="position-relative filter w-100 pb-4 pb-md-5">
          <h5 class="font-weight-bold">{{topFilter.title}}</h5>
          <div class="w-100 divider"></div>
          <div class="d-flex flex-wrap pt-4 justify-content-start">
            <div
              v-for="filter in availableFilters(topFilter.content)"
              :key="`subfilter-${filter}`"
              class="cursor-pointer py-2 px-3 filter-item m-2"
              @click="toggleFilter(topIndex,filter, true)"
              :class="{'active': isFilterActive(filter, topIndex)}"
            >
              <div class="text-center small">{{getContent(filter).title}}</div>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-center pb-4 pb-md-5 flex-column flex-md-row">
          <button class="btn btn-primary mr-md-3" @click="closeModal()">{{ft('globals.go')}}</button>
          <button class="btn btn-dark mt-3 mt-md-0" @click="initFilters(true)">{{ft('globals.reset')}}</button>
        </div>
      </div>
    </transition>
    <!-- END MODAL -->
  </div>
</template>

<style lang="scss" scoped>
[filters-component] {
  .filters-toggler {
    border: 1px solid black;
    border-radius: 6px;
    width: 16rem;
    transition: all .25s;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }

    & > i {
      transition: color .25s;
    }

    &:hover, &:focus {
      border-color: $primary;

      & > i {
        color: $primary;
      }
    }
  }

  .layer, .filter-menu {
    overflow: auto;
    height: calc(100vh - #{$header-height});
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    @include media-breakpoint-down(sm) {
      height: calc(100vh - #{$header-height-sm});
    }
  }

  .layer {
    .close-icon {
      width: 3.5rem;
      height: 3.5rem;
      top: 0;
      right: 0;
      color: white;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: color .25s;

      & > i {
        line-height: 1.5rem;
        @include font-size(1.5rem);
      }

      &:hover {
        color: $gray-300;
      }
    }
  }

  .filter-item, .filter-menu .filter-item {
    border-radius: 3rem;
    background-color: $gray-200;
    transition: all .25s;

    &:hover {
      color: $gray-600;
    }

    &.active {
      background-color: $primary;
      color: $white;
    }
  }

  .filter-menu {
    width: calc(100% - 3.5rem);
    border-bottom-right-radius: 16px;

    .divider {
      height: 1px;
      background-color: #ebebeb;
    }
  }

  [grid-isotope-component] {
    position: relative;
  }
}
</style>
